// extracted by mini-css-extract-plugin
module.exports = {"container":"AttentionMessage_container__3ARaT","alertIcon":"AttentionMessage_alertIcon__AF9RG"};